import { z } from 'zod'

/** A directory the user keeps coming back to on one server (PROMPT.md §5.7). */
export const bookmarkSchema = z.object({
  id: z.string(),
  serverId: z.string(),
  label: z.string(),
  remotePath: z.string(),
  sortOrder: z.number().int(),
  createdAt: z.iso.datetime(),
})
export type Bookmark = z.infer<typeof bookmarkSchema>

export const createBookmarkSchema = z.object({
  label: z
    .string()
    .trim()
    .min(1, 'Das Lesezeichen braucht einen Namen.')
    .max(80, 'Höchstens 80 Zeichen.'),
  remotePath: z
    .string()
    .trim()
    .min(1, 'Es wurde kein Pfad angegeben.')
    .startsWith('/', 'Der Pfad muss mit / beginnen.'),
})

export const bookmarkIdParamsSchema = z.object({
  serverId: z.string().min(1),
  id: z.string().min(1),
})
export const bookmarkServerParamsSchema = z.object({ serverId: z.string().min(1) })
